import React from "react";

const News = () => {
  return (
    <div>
      <section class="inner-banner">
        <div class="thm-container">
          <h2>Stay Updated with Technociv Technologies</h2>
          <div class="breadcumb">
            {/* <a href="/">Home</a>
            <i class="fa fa-angle-right"></i> */}
            <span>
              Welcome to the News Column of Technociv Technologies Pvt. Ltd.!
              Here, you'll find the latest updates, announcements, and insights
              from our team. Stay informed about our innovations, project
              launches, industry trends, and more.
            </span>
          </div>
        </div>
      </section>
      <div class="full_wrapper padtb_100_95">
        <div class="container">
          <div class="row">
            <div class="col-lg-3 col-md-4 col-sm-12 col-xs-12">
              {/* <div id="search-2" class="full_width widget mbot45 widget_search">
                <div class="hdr_search news_search">
                  <form role="search" class="navbar-form navbar-left">
                    <input type="text" value="Enter Search Keywords" onblur="if(value=='') value = 'Enter Search Keywords'" onfocus="if(value=='Enter Search Keywords') value = ''" class="form-control" name="s" id="s" />
                    <button type="submit" class="btn btn-default"></button>
                  </form>
                </div>
              </div> */}
              <div
                id="recent-posts-2"
                class="full_width widget mbot45 widget_news"
              >
                <h3 class="fnt_25 mbot25">Recent Posts</h3>
                <ul class="recent_list">
                  <li>
                    <h6>
                        New Launch: Test Jig for DCU SCP & MCU Card.
                    </h6>
                    <p>December 4, 2024</p>
                  </li>
                  <li>
                    <h6>
                     
                        New Launch: End-of-Line (EOL) Testing for Electric
                        Vehicle (EV) Motors & MCU
                    </h6>
                    <p>Jan 14th, 2025</p>
                  </li>
                  {/* <li>
                    <h6>
                      Customized Composite Tester for LG
                    </h6>
                    <p>August 21st, 2024</p>
                  </li> */}
                  {/* <li>
                    <h6>
                    EOL Test System for Sandhar Auto Electric – DC-DC Converter
                    </h6>
                    <p>Sept 23, 2024</p>
                  </li> */}
                  {/* <li>
                    <h6>
                      End-of-Line (EOL) Testing for Off-Board Electric Vehicle (EV) Chargers
                    </h6>
                    <p>May 3, 2018</p>
                  </li> */}
                  <li>
                    <h6>
                      Participation in Technology Day 2023-24 at TATA MOTORS, Pantnagar.
                    </h6>
                    <p>March 5, 2024</p>
                  </li>
                </ul>
              </div>
              <div
                id="categories-2"
                class="full_width widget mbot45 widget_categories"
              >
                <h3 class="fnt_25 mbot25">Categories</h3>
                <ul>
                  <li class="cat-item cat-item-2">
                    <a href="">industry</a>
                  </li>
                  <li class="cat-item cat-item-3">
                    <a href="">manufactring</a>
                  </li>
                  <li class="cat-item cat-item-4">
                    <a href="">Automation</a>
                  </li>
                </ul>
              </div>
              {/* <div
                id="tag_cloud-2"
                class="full_width widget mbot45 widget_tag_cloud"
              >
                <h3 class="fnt_25 mbot25">Tags</h3>
                <div class="tagcloud">
                  <ul class="wp-tag-cloud" role="list">
                    <li>
                      <a
                        href=""
                        class="tag-cloud-link tag-link-9 tag-link-position-1"
                        style={{ fontSize: "11px" }}
                        aria-label="Awarads (1 item)"
                      >
                        Awarads
                      </a>
                    </li>
                    <li>
                      <a
                        href=""
                        class="tag-cloud-link tag-link-5 tag-link-position-2"
                        style={{ fontSize: "11px" }}
                        aria-label="Industry (1 item)"
                      >
                        Industry
                      </a>
                    </li>
                    <li>
                      <a
                        href=""
                        class="tag-cloud-link tag-link-8 tag-link-position-3"
                        style={{ fontSize: "11px" }}
                        aria-label="Manufactures (1 item)"
                      >
                        Manufactures
                      </a>
                    </li>
                    <li>
                      <a
                        href=""
                        class="tag-cloud-link tag-link-6 tag-link-position-4"
                        style={{ fontSize: "11px" }}
                        aria-label="Mechanical (1 item)"
                      >
                        Mechanical
                      </a>
                    </li>
                    <li>
                      <a
                        href=""
                        class="tag-cloud-link tag-link-10 tag-link-position-5"
                        style={{ fontSize: "11px" }}
                        aria-label="Projects (1 item)"
                      >
                        Projects
                      </a>
                    </li>
                    <li>
                      <a
                        href=""
                        class="tag-cloud-link tag-link-7 tag-link-position-6"
                        style={{ fontSize: "11px" }}
                        aria-label="Repairs (1 item)"
                      >
                        Repairs
                      </a>
                    </li>
                  </ul>
                </div>
              </div> */}
            </div>
            <div class="col-lg-9 col-md-8 col-sm-12 col-xs-12 col_margin">
              <div class="plft30">
                <div class="full_width mbot80">
                  <div class="wdt_img news_img shadow_effect effect-apollo">
                    <a href="#">
                      <img
                        width="840"
                        height="360"
                        src="/img/newlaunch1.jpg"
                        class="attachment-post-thumbnail size-post-thumbnail wp-post-image"
                        alt=""
                        sizes="(max-width: 840px) 100vw, 840px"
                      />
                      <span class="news_Date news_Date1">Dec 4, 2024</span>
                    </a>
                  </div>
                  <ul class="blog_icon_list">
                    <li class="blog-user_icon">By:admin</li>
                    <li class="blog-lawn_icon">
                      <a href="#" rel="category">
                        industry{" "}
                      </a>
                      /{" "}
                      <a href="#" rel="category">
                        manufactring{" "}
                      </a>
                      /{" "}
                      <a href="#" rel="category">
                        Automation{" "}
                      </a>
                    </li>
                    <li class="blog-cmt_icon">
                      <a href="#">
                        No Comments
                        <span class="screen-reader-text">
                          {" "}
                          on Our Complete value chain of oil processing &#038;
                          transportation
                        </span>
                      </a>
                    </li>
                  </ul>
                  <h3 class="fnt_25 mbot20 news_head no_after">
                    <a href="#">New Launch: Test Jig for DCU SCP & MCU Card</a>
                  </h3>
                  <p class="mbot25 gray_color1 clear-none">
                    We are excited to announce the launch of our latest
                    automation solution: the Test Jig designed for DCU SCP (Data
                    Control Unit Secure Control Protocol) & MCU (Microcontroller
                    Unit) Card, as well as LRU SCP & MCU Card. This advanced
                    testing solution streamlines the testing process, ensuring
                    efficiency and accuracy in validating critical components.
                  </p>

                  <p>
                    <strong>Key Features:</strong>
                  </p>
                  <ul class="list-unstyled mbot25">
                    <li>
                      <strong>One-Click Operation:</strong> All test programs
                      can be executed simultaneously with the simple press of a
                      start button, minimizing setup time and enhancing
                      productivity.
                    </li>
                    <li>
                      <strong>Fully Automated Testing:</strong> The system
                      requires no manual intervention during testing, allowing
                      for a hands-free experience that reduces the risk of human
                      error.
                    </li>
                    <li>
                      <strong>User-Friendly Interface:</strong> Designed for
                      ease of operation, the Test Jig features an intuitive
                      interface that makes it accessible for all users,
                      regardless of technical expertise.
                    </li>
                    <li>
                      <strong>Data Storage in Excel Format:</strong> Test
                      results can be easily stored and exported in Excel format,
                      facilitating data analysis and reporting.
                    </li>
                    <li>
                      <strong>Unique Part Tracking:</strong> Each part is
                      assigned a unique identity, making it easy to track and
                      manage components throughout the testing process.
                    </li>
                  </ul>

                  <p>
                    This innovative Test Jig is a testament to our commitment to
                    providing cutting-edge automation solutions that meet the
                    needs of the automotive and electronics industries. With its
                    advanced features, you can enhance your testing processes
                    and ensure the highest quality standards for your products.
                  </p>

                  <p>
                    For more information or to schedule a demonstration, please
                    contact us at{" "}
                    <a
                      href="mailto:info@technociv.com"
                      className="text-primary"
                    >
                      info@technociv.com
                    </a>
                  </p>

                  <hr />

              
                {/* </div>
                <div class="full_width mbot80"> */}
                  {/* <div class="wdt_img news_img shadow_effect effect-apollo">
                    <a href="#">
                      <img
                        width="840"
                        height="360"
                        src="/img/news_img2.jpg"
                        class="attachment-post-thumbnail size-post-thumbnail wp-post-image"
                        alt=""
                        sizes="(max-width: 840px) 100vw, 840px"
                      />
                      <span class="news_Date news_Date1">May 3, 2018</span>
                    </a>
                  </div> */}
                  {/* <ul class="blog_icon_list">
                    <li class="blog-user_icon">By:admin</li>
                    <li class="blog-lawn_icon">
                      <a href="#" rel="category">
                        industry{" "}
                      </a>
                      /{" "}
                      <a href="#" rel="category">
                        manufactring{" "}
                      </a>
                      /{" "}
                      <a href="#" rel="category">
                        metal{" "}
                      </a>
                    </li>
                    <li class="blog-cmt_icon">
                      <a href="#">
                        No Comments
                        <span class="screen-reader-text">
                          {" "}
                          on Our Complete value chain of oil processing &#038;
                          transportation
                        </span>
                      </a>
                    </li>
                  </ul> */}
                    <div class="full_width ">
                  <div class="wdt_img news_img shadow_effect effect-apollo">
                    <a href="#">
                      <img
                        width="840"
                        height="360"
                        src="/img/newlaunch2.jpg"
                        class="attachment-post-thumbnail size-post-thumbnail wp-post-image"
                        alt=""
                        sizes="(max-width: 840px) 100vw, 840px"
                      />
                      <span class="news_Date news_Date1">Jan 14, 2025</span>
                    </a>
                  </div>
                  <ul class="blog_icon_list">
                    <li class="blog-user_icon">By:admin</li>
                    <li class="blog-lawn_icon">
                      <a href="#" rel="category">
                        industry{" "}
                      </a>
                      /{" "}
                      <a href="#" rel="category">
                        manufactring{" "}
                      </a>
                      /{" "}
                      <a href="#" rel="category">
                      Automation{" "}
                      </a>
                    </li>
                    <li class="blog-cmt_icon">
                      <a href="#">
                        No Comments
                        <span class="screen-reader-text">
                          {" "}
                          on Our Complete value chain of oil processing &#038;
                          transportation
                        </span>
                      </a>
                    </li>
                  </ul>
                 
                </div>
                  <h3 class="fnt_25 mbot20 news_head no_after">
                    <a href="#">
                      {" "}
                      New Launch: End-of-Line (EOL) Testing for Electric Vehicle
                      (EV) Motors & MCU
                    </a>
                  </h3>
                  <p class="mbot25 gray_color1 clear-none">
                  We are currently engaged in an ongoing project for Sandhar, where we are implementing our advanced test systems tailored for EOL testing of EV motors. This collaboration aims to enhance quality assurance processes and ensure that every motor meets the stringent demands of the electric vehicle industry.
Our End-of-Line (EOL) Testing solution for Electric Vehicle (EV) Motors is designed to ensure that each motor meets the highest performance, quality, and safety standards before shipment. 

                  </p>
                
                </div>
                <div class="full_width mbot80">
                  <div class="wdt_img news_img shadow_effect effect-apollo">
                    <a href="#">
                      <img
                        width="840"
                        height="360"
                        src="/img/news3.jpg"
                        class="attachment-post-thumbnail size-post-thumbnail wp-post-image"
                        alt=""
                        sizes="(max-width: 840px) 100vw, 840px"
                      />
                      <span class="news_Date news_Date1">March 5, 2024</span>
                    </a>
                  
                  </div>
                  <a href="#">
                      <img
                        width="840"
                        // height="360"
                        src="/img/NEWS4.jpg"
                        class="attachment-post-thumbnail size-post-thumbnail wp-post-image"
                        alt=""
                        // sizes="(max-width: 840px) 100vw, 840px"
                      />
                    </a>
                  <ul class="blog_icon_list">
                    <li class="blog-user_icon"> By :admin</li>
                    <li class="blog-lawn_icon">
                      <a href="#" rel="category">
                        industry{" "}
                      </a>
                      /{" "}
                      <a href="#" rel="category">
                        manufactring{" "}
                      </a>
                      /{" "}
                      <a href="#" rel="category">
                      Automation{" "}
                      </a>
                    </li>
                    <li class="blog-cmt_icon">
                      <a href="#">
                        No Comments
                        <span class="screen-reader-text">
                          {" "}
                          on Our Complete value chain of oil processing &#038;
                          transportation
                        </span>
                      </a>
                    </li>
                  </ul>
                  <h3 class="fnt_25 mbot20 news_head no_after">
                    <a href="#">
                    Participation in Technology Day 2023-24 at TATA MOTORS, Pantnagar.
                    </a>
                  </h3>
                  <p class="mbot25 gray_color1 clear-none">
                  Technociv Technologies recently participated in Technology Day, where we showcased our innovative testing and automation solutions. The event provided an excellent platform for networking and exchanging ideas with industry leaders.
                  </p>
                  {/* <a
                    href="#"
                    class="view-all hvr-bounce-to-right news_read_btn"
                  >
                    Read More
                  </a> */}
                </div>

                <div aria-label="Page navigation"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default News;
